import React from 'react'

import Window from '../../Window'
import { useDetailsMeta } from '../detailsContext'

const WindowMarkup = ({
  identifier,
  name,
  uri,
  icon,
  onClose,
  children,
  ID,
  hash,
  tabs,
  data,
  Header,
  Footer,
  openContext,
  isModal,
  search,
}) => {
  const { onRefresh } = useDetailsMeta()

  return (
    <Window
      id={identifier}
      uri={uri}
      icon={icon}
      headerText={name}
      onClose={onClose}
      search={search}
      footer={
        Footer ? (
          <Footer
            isModal={isModal}
            openContext={openContext}
            ID={ID}
            hash={hash}
            tabs={tabs}
            data={data}
            onRefresh={onRefresh}
          />
        ) : null
      }
    >
      {Header && <Header ID={ID} hash={hash} tabs={tabs} data={data} />}
      {children}
    </Window>
  )
}

export default WindowMarkup
